import { BlockTypeSelect, BoldItalicUnderlineToggles, codeBlockPlugin, codeMirrorPlugin, CreateLink, diffSourcePlugin, DiffSourceToggleWrapper, headingsPlugin, imagePlugin, InsertCodeBlock, InsertImage, InsertTable, InsertThematicBreak, linkDialogPlugin, linkPlugin, listsPlugin, ListsToggle, quotePlugin, RealmPlugin, StrikeThroughSupSubToggles, tablePlugin, thematicBreakPlugin, toolbarPlugin, UndoRedo } from "@mdxeditor/editor";
import { API } from "../../API";
import { InsertFile } from "./InsertFile";

export class MdxPlugins {

    public static images(api: API, issueId: number): RealmPlugin {
        return imagePlugin({
            imageUploadHandler: async (image: File) =>  {
                const fileUrl = await api.uploadIssueAttach(issueId, image, image.name);
                return fileUrl;
            }
        });
    }

    public static standardPlugins(api: API, issueId?: number, diffMarkdown?: string | undefined, mobile: boolean = false): RealmPlugin[] {
        const result = [] as RealmPlugin[];
        if (issueId) {
            result.push(imagePlugin({
                imageUploadHandler: async (image: File) => {
                    const fileUrl = await api.uploadIssueAttach(issueId, image, image.name);
                    return fileUrl;
                }
            }));

            result.push(imagePlugin({
                imageUploadHandler: async (image: File) => {
                    const fileUrl = await api.uploadIssueAttach(issueId, image, image.name);
                    return fileUrl;
                }
            }));
        }

        return result.concat([
            listsPlugin(),
            linkPlugin(),
            codeBlockPlugin({ defaultCodeBlockLanguage: 'ts' }),
            codeMirrorPlugin({
                codeBlockLanguages: {
                    js: 'JavaScript',
                    css: 'CSS',
                    ts: 'TypeScript',
                    tsx: 'TSX',
                    jsx: 'JSX',
                }
            }),
            linkDialogPlugin(),
            quotePlugin(),
            headingsPlugin({ allowedHeadingLevels: [1, 2, 3, 4, 5, 6] }),
            quotePlugin(),
            tablePlugin(),
            thematicBreakPlugin(),
            diffSourcePlugin({ diffMarkdown: diffMarkdown, viewMode: 'rich-text' }),
            toolbarPlugin({
                toolbarClassName: 'my-classname',
                toolbarContents: () => {
                    return (
                        mobile?
                            <>
                                {' '}
                                <BoldItalicUnderlineToggles />
                                <ListsToggle options={['bullet', 'number']} />
                                {issueId ? <InsertImage /> : ''}
                                <CreateLink />
                            </>
                            :
                            <DiffSourceToggleWrapper>
                                {' '}
                                <UndoRedo />
                                <BoldItalicUnderlineToggles />
                                <StrikeThroughSupSubToggles />
                                <BlockTypeSelect />
                                <ListsToggle />
                                {issueId ? <InsertImage /> : ''}
                                <CreateLink />
                                <InsertThematicBreak />
                                <InsertTable />
                                <InsertCodeBlock />
                                {issueId &&
                                    <InsertFile uploadFile={async (f) => await api.uploadIssueAttach(issueId, f, f.name) } />
                                }
                            </DiffSourceToggleWrapper>
                    )
                }
            })
        ]);
    }
}

/*function tablePlugin(): RealmPlugin {
    throw new Error("Function not implemented.");
}*/
